import React from "react";
import "./ModalViewerPreCollection.scss"

import { Modal } from "flowbite-react";
import { IVehicleVisualRecord } from "@/types/vehicle-visual-record.type";
import Loading from "@/common/components/ui/loading/Loading";
import { getPreCollectionById } from "@/common/services/pre-collection.api";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { UploadDocumentField } from "@/modules/renters/components/forms/fields/UploadDocumentField";
import { UploadImageField } from "@/common/components/form/UploadImageField/UploadImageField";
import { Badge } from "@/components/ui/badge";

type Props = {
  open: boolean;
  data: { preCollectionId: string; }
  onClose: () => void
}


export default function ModalViewerPreCollection({ open, data, onClose }: Props) {
  const { notifyError } = useToastContext();

  const [loading, setLoading] = React.useState<boolean>(true);
  const [precollection, setPrecollection] = React.useState<IVehicleVisualRecord | null>(null);



  const onHandleGetPreCollection = React.useCallback(async () => {
    setLoading(true);

    try {
      const response = await getPreCollectionById(data.preCollectionId);

      if (response.ok) {
        setPrecollection(response.data as IVehicleVisualRecord);
      } else {
        notifyError(response.message as string);
      }
    } catch (error) {
      console.error("Erro ao carregar os dados do pré-recolhimento:", error);
      notifyError("Erro ao carregar os dados do pré-recolhimento.");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.preCollectionId]);

  React.useEffect(() => { onHandleGetPreCollection() }, [onHandleGetPreCollection, open])

  return (
    <Modal show={open} size="4xl" onClose={onClose} popup>
      <Modal.Header />
      <Modal.Body>
        {loading ? (
          <div className="h-[50vh] flex justify-center items-center overflow-y-hidden">
            <Loading />
          </div>
        ) : precollection ? (
          (
            <div className="min-h-[50vh] text-center ">
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Visualizador de Pré-Recolhimento
              </h3>

              <div className="flex items-start flex-col gap-2 mb-4 space-y-2">
                <p>Dados do Recolhedor</p>
                <p className="w-full flex flex-col items-start border p-2">
                  <span>
                    Nome: {precollection.vehicleCollector?.name}
                  </span>
                  <span>
                    CPF: {precollection.vehicleCollector?.document}
                  </span>
                  <span>
                    Data do Recolhimento: {precollection.vehicleCollector?.collectDate ? new Date(precollection.vehicleCollector.collectDate).toLocaleDateString() : 'N/A'}
                  </span>

                  <div>
                    <p className="mt-2 font-semibold">Selfie com Endereço:</p>

                    <div>
                      {precollection.vehicleCollector?.selfieWithAddress ? (
                        <div className="row-span-3">
                          <UploadDocumentField
                            currentSrc={precollection.vehicleCollector.selfieWithAddress}
                            pathToUpload={`pre-collection/${precollection._id}/selfie-with-address`}
                            handleUploadSrc={() => { }}
                          >
                            {({ src, onNewFile, onRemoveClick }) => (
                              <UploadImageField
                                src={src}
                                onNewFile={onNewFile}
                                onRemoveClick={onRemoveClick}
                                disableTrashIcon
                              />
                            )}
                          </UploadDocumentField>
                        </div>
                      ) : (
                        <span>Nenhuma selfie disponível.</span>
                      )}
                    </div>
                  </div>
                </p>
              </div>

              <div className="flex items-start flex-col gap-2 mb-4 space-y-2">
                <p>Pagamentos</p>
                <p className="w-full flex flex-col items-start border p-2">
                  <span>
                    Debito quitado: <Badge variant={precollection.vehicleCollector?.debitInformation.isPaid ? 'default' : 'destructive'}>
                      {precollection.vehicleCollector?.debitInformation.isPaid ? 'Sim' : 'Não'}
                    </Badge>
                  </span>

                  {precollection.vehicleCollector?.debitInformation.isPaid && (
                    <div>
                      <p className="mt-2 font-semibold">Comprovante de Pagamento:</p>

                      <div>
                        {precollection.vehicleCollector?.selfieWithAddress ? (
                          <div className="row-span-3">
                            <UploadDocumentField
                              currentSrc={precollection.vehicleCollector.debitInformation.paymentProof}
                              pathToUpload={`pre-collection/${precollection._id}/payment-proof`}
                              handleUploadSrc={() => { }}
                            >
                              {({ src, onNewFile, onRemoveClick }) => (
                                <UploadImageField
                                  src={src}
                                  onNewFile={onNewFile}
                                  onRemoveClick={onRemoveClick}
                                  disableTrashIcon
                                />
                              )}
                            </UploadDocumentField>
                          </div>
                        ) : (
                          <span>Nenhuma selfie disponível.</span>
                        )}
                      </div>
                    </div>
                  )}
                </p>
              </div>

              <div className="flex items-start flex-col gap-2 mb-4 space-y-2">
                <p>Localização</p>
                <p className="w-full flex flex-col items-start border p-2">
                  <span>
                    Data da Localização: {precollection.vehicleCollector?.location.currentTime ? new Date(precollection.vehicleCollector.location.currentTime).toLocaleString() : 'N/A'}
                  </span>

                  <span>
                    Localização no Mapa:{" "} <a href={precollection.vehicleCollector?.location.mapsUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">Ver no Google Maps</a>
                  </span>
                </p>
              </div>

            </div>
          )
        ) : (
          <div className="h-[70vh] flex justify-center items-center">
            <p>Nenhum dado de pré-recolhimento disponível.</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}